module.exports = __webpack_public_path__ + "static/media/whitelogo.86f81667.png";